import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Grid from '@mui/material/Grid2';

export type FolderDialogMode = 'create' | 'rename';

interface ChatSidebarFolderDialogProps {
  open: boolean;
  mode: FolderDialogMode;
  initialName?: string;
  onClose: () => void;
  onSubmit: (name: string) => void;
}

/** דיאלוג ליצירה/שינוי-שם של תיקיית סרגל-צד (תואם בסגנון לדיאלוג יצירת תצוגה) */
function ChatSidebarFolderDialog({ open, mode, initialName = '', onClose, onSubmit }: ChatSidebarFolderDialogProps) {
  const [name, setName] = React.useState(initialName);

  React.useEffect(() => {
    if (open) setName(initialName);
  }, [open, initialName]);

  const handleSubmit = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
    onClose();
  };

  return (
    <Dialog onClose={onClose} open={open} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Grid container spacing={2} alignItems="center">
          <Grid size="grow">{mode === 'create' ? 'תיקייה חדשה' : 'שינוי שם תיקייה'}</Grid>
          <Grid size="auto">
            <IconButton onClick={onClose}>
              <CloseOutlinedIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent sx={{ pt: '12px !important' }}>
        <TextField
          autoFocus
          fullWidth
          size="small"
          label="שם התיקייה"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSubmit();
            }
          }}
        />
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          py: 2,
          gap: 1.5,
          justifyContent: 'flex-end',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Button variant="outlined" color="error" onClick={onClose}>
          ביטול
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={name.trim() === ''}>
          {mode === 'create' ? 'צור' : 'שמור'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ChatSidebarFolderDialog;
